import { render } from "./ExportScheme.vue?vue&type=template&id=67e20a30&scoped=true"
import script from "./ExportScheme.vue?vue&type=script&lang=js"
export * from "./ExportScheme.vue?vue&type=script&lang=js"

import "./ExportScheme.vue?vue&type=style&index=0&id=67e20a30&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67e20a30"

export default script